const DASH = '—';

export function formatExpectedLifeKm(km: number | null): string {
  return km === null ? DASH : `${new Intl.NumberFormat('en-KE').format(km)} km`;
}

export function formatExpectedLifeDays(days: number | null): string {
  return days === null ? DASH : `${new Intl.NumberFormat('en-KE').format(days)} days`;
}
